// extracted by mini-css-extract-plugin
export default {"inputBox":"inputBox_styles_inputBox__0nShk","requiredSing":"inputBox_styles_requiredSing__aiKVa"};